export function newIdempotencyKey(): string {
  const uuid = globalThis.crypto?.randomUUID?.()
  return uuid ?? `ia-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`
}
